import { BaseResponse, requestApi } from '~/services/api-new';

export type RealityCheckNetherlandsResponse = {
	ordinal: number;
	text: string;
	delayMillis: number;
};

export const startRealityCheckNetherlands = async () =>
	requestApi({ endpoint: '/player/server-reality-check/start', method: 'POST' });

export const recordRealityCheckNotificationNetherlands = async (notificationId: number) => {
	return requestApi<BaseResponse<RealityCheckNetherlandsResponse>>({
		endpoint: `/player/server-reality-check/notification/show/${notificationId}`,
		method: 'POST'
	});
};

export const getRealityCheckNotificationInfoNetherlands = async () =>
	requestApi<BaseResponse<RealityCheckNetherlandsResponse>>({
		endpoint: '/player/server-reality-check/notification/next',
		method: 'GET'
	});
